var _defs, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _g3, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c39217f216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 2.585938 L 29.515625 2.585938 L 29.515625 22 L 0.484375 22 Z M 0.484375 2.585938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3e47ddced"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 18 L 29.515625 18 L 29.515625 20 L 0.484375 20 Z M 0.484375 18 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "670341006e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 23 L 25 23 L 25 25.8125 L 5 25.8125 Z M 5 23 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.765625 19.085938 L 3.765625 5.980469 C 3.765625 5.839844 3.820312 5.71875 3.910156 5.628906 C 4.003906 5.535156 4.125 5.480469 4.261719 5.480469 L 25.738281 5.480469 C 25.875 5.480469 26 5.535156 26.089844 5.628906 C 26.179688 5.71875 26.234375 5.839844 26.234375 5.980469 L 26.234375 19.585938 L 27.234375 19.585938 L 27.234375 5.980469 C 27.234375 5.570312 27.066406 5.191406 26.792969 4.921875 C 26.527344 4.652344 26.148438 4.484375 25.738281 4.484375 L 4.261719 4.484375 C 3.851562 4.484375 3.472656 4.652344 3.207031 4.921875 C 2.933594 5.191406 2.765625 5.570312 2.765625 5.980469 L 2.765625 19.585938 L 3.765625 19.585938 L 3.765625 19.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.328125 21.480469 L 17.332031 21.480469 L 17.332031 23.472656 L 18.328125 23.472656 L 18.328125 21.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.667969 21.480469 L 11.671875 21.480469 L 11.671875 23.472656 L 12.667969 23.472656 L 12.667969 21.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c39217f216)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 29.492188 19.585938 L 28.496094 19.585938 L 28.496094 19.683594 L 29.492188 19.683594 L 29.492188 19.585938 M 27.699219 2.589844 L 2.300781 2.589844 C 1.808594 2.589844 1.355469 2.792969 1.035156 3.117188 C 0.710938 3.441406 0.507812 3.890625 0.507812 4.386719 L 0.507812 19.683594 C 0.507812 20.179688 0.710938 20.628906 1.035156 20.953125 C 1.355469 21.277344 1.808594 21.480469 2.300781 21.480469 L 11.671875 21.480469 L 11.671875 20.480469 L 12.667969 20.480469 L 12.667969 21.480469 L 17.332031 21.480469 L 17.332031 20.480469 L 18.328125 20.480469 L 18.328125 21.480469 L 27.699219 21.480469 C 28.191406 21.480469 28.644531 21.277344 28.964844 20.953125 C 29.289062 20.628906 29.492188 20.179688 29.492188 19.683594 L 28.496094 19.683594 C 28.496094 19.90625 28.40625 20.101562 28.261719 20.25 C 28.117188 20.394531 27.917969 20.480469 27.699219 20.480469 L 2.300781 20.480469 C 2.082031 20.480469 1.882812 20.394531 1.738281 20.25 C 1.59375 20.101562 1.503906 19.90625 1.503906 19.683594 L 1.503906 19.585938 L 0.507812 19.585938 L 0.507812 18.589844 L 1.503906 18.589844 L 1.503906 4.386719 C 1.503906 4.164062 1.59375 3.96875 1.738281 3.820312 C 1.882812 3.675781 2.082031 3.589844 2.300781 3.589844 L 27.699219 3.589844 C 27.917969 3.589844 28.117188 3.675781 28.261719 3.820312 C 28.40625 3.96875 28.496094 4.164062 28.496094 4.386719 L 28.496094 18.589844 L 29.492188 18.589844 L 29.492188 4.386719 C 29.492188 3.890625 29.289062 3.441406 28.964844 3.117188 C 28.644531 2.792969 28.191406 2.589844 27.699219 2.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.328125 20.480469 L 17.332031 20.480469 L 17.332031 21.480469 L 18.328125 21.480469 L 18.328125 20.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.667969 20.480469 L 11.671875 20.480469 L 11.671875 21.480469 L 12.667969 21.480469 L 12.667969 20.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 2.765625 18.589844 L 1.503906 18.589844 L 1.503906 19.585938 L 2.765625 19.585938 L 2.765625 18.589844 M 26.234375 18.589844 L 3.765625 18.589844 L 3.765625 19.585938 L 26.234375 19.585938 L 26.234375 18.589844 M 28.496094 18.589844 L 27.234375 18.589844 L 27.234375 19.585938 L 28.496094 19.585938 L 28.496094 18.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.765625 18.589844 L 2.765625 18.589844 L 2.765625 19.585938 L 3.765625 19.585938 L 3.765625 18.589844 M 27.234375 18.589844 L 26.234375 18.589844 L 26.234375 19.585938 L 27.234375 19.585938 L 27.234375 18.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3e47ddced)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1.503906 18.589844 L 0.507812 18.589844 L 0.507812 19.585938 L 1.503906 19.585938 L 1.503906 18.589844 M 29.492188 18.589844 L 28.496094 18.589844 L 28.496094 19.585938 L 29.492188 19.585938 L 29.492188 18.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#670341006e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.332031 23.472656 L 12.667969 23.472656 L 12.667969 24.46875 L 17.332031 24.46875 L 17.332031 23.472656 M 24.019531 23.472656 L 18.328125 23.472656 L 18.328125 24.46875 L 23.523438 24.46875 L 23.523438 25.128906 L 6.476562 25.128906 L 6.476562 24.46875 L 11.671875 24.46875 L 11.671875 23.472656 L 5.980469 23.472656 C 5.847656 23.472656 5.71875 23.527344 5.628906 23.617188 C 5.535156 23.710938 5.480469 23.839844 5.480469 23.972656 L 5.480469 25.625 C 5.480469 25.757812 5.535156 25.886719 5.628906 25.976562 C 5.71875 26.070312 5.847656 26.125 5.980469 26.125 L 24.019531 26.125 C 24.152344 26.125 24.28125 26.070312 24.371094 25.976562 C 24.464844 25.886719 24.519531 25.757812 24.519531 25.625 L 24.019531 25.625 L 24.019531 25.125 L 24.019531 25.625 L 24.519531 25.625 L 24.519531 23.972656 C 24.519531 23.839844 24.464844 23.710938 24.371094 23.617188 C 24.28125 23.527344 24.152344 23.472656 24.019531 23.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.328125 23.472656 L 17.332031 23.472656 L 17.332031 24.46875 L 18.328125 24.46875 L 18.328125 23.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.667969 23.472656 L 11.671875 23.472656 L 11.671875 24.46875 L 12.667969 24.46875 L 12.667969 23.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.847716ef540699b6331d78b0e5feac51.svg";
export { ForwardRef as ReactComponent };